import MenuItem from './../../menu/menuItem/MenuItem.vue'
import DetailsSummary from './../../detailsSummary/DetailsSummary.vue'

export default {
  name: 'help-menu',
  components: {
    MenuItem,
    DetailsSummary
  }
}
